import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const steps = [
  {
    title: 'Submit Requests',
    description: 'Easily submit new design or dev requests from your dashboard.'
  },
  {
    title: 'How the Queue Works',
    description: 'We work on one active request at a time. You can add more to your queue.'
  },
  {
    title: 'Track Progress',
    description: 'See the status of your requests and communicate with our team in real time.'
  },
  {
    title: 'Communicate',
    description: 'Chat with us directly on each request for updates and feedback.'
  }
];

const OnboardingWelcome: React.FC = () => {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full relative">
        <h2 className="text-2xl font-bold mb-4 text-center">Welcome!</h2>
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">{steps[step].title}</h3>
          <p className="text-gray-700">{steps[step].description}</p>
        </div>
        <div className="flex justify-between">
          <button
            className="px-4 py-2 bg-gray-200 rounded"
            onClick={() => setStep(s => Math.max(0, s - 1))}
            disabled={step === 0}
          >
            Back
          </button>
          {step < steps.length - 1 ? (
            <button
              className="px-4 py-2 bg-primary text-white rounded"
              onClick={() => setStep(s => s + 1)}
            >
              Next
            </button>
          ) : (
            <button
              className="px-4 py-2 bg-primary text-white rounded"
              onClick={() => navigate('/onboarding/first-request')}
            >
              Continue
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingWelcome; 